import { render } from "./Modals.vue?vue&type=template&id=0fd15de1&scoped=true"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd15de1"]])

export default __exports__